<template>
  <div class="notify" :class="data.item.type">
    <div class="notify__inner">
      <div class="notify__icon">
        <i v-if="data.item.type === $notificationService.NOTIFY_TYPE.SUCCESS" class="ri-checkbox-circle-line"></i>
        <i v-if="data.item.type === $notificationService.NOTIFY_TYPE.WARNING" class="ri-alert-line"></i>
        <i v-if="data.item.type === $notificationService.NOTIFY_TYPE.ERROR" class="ri-spam-2-line"></i>
      </div>
      <div class="notify__text">{{ data.item.text | translate }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data']
}
</script>

<style lang="scss" scoped>
  .notify {
    padding: 0 20px 20px 0;
    &__inner {
      border-radius: 13px;
      padding: 8px 16px;
      display: flex;
      align-items: flex-start;
      color: var(--light-01);
    }
    &__icon {
      margin-right: 8px;
      i {
        font-size: 24px;
        vertical-align: middle;
      }
    }
    &__text {
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
    }
    &.success {
      .notify__inner {
        background: var(--accent-green);
      }
    }
    &.warn {
      .notify__inner {
        background: var(--accent-yellow);
      }
    }
    &.error {
      .notify__inner {
        background: var(--accent-red);
      }
    }
  }
</style>
